export default {
  "Audio Compressor": "Ses Sıkıştırıcı",
  "HitPaw Online Audio Compressor": "HitPaw Çevrimiçi Ses Sıkıştırıcı",
  "Reduce audio file size online without quality loss.": "Kalite kaybı olmadan çevrimiçi ses dosyası boyutunu azaltın.",
  "Compress": "Sıkıştır",
  "Compressing": "Sıkıştırma",
  "Compressed Successfully": "Başarıyla Sıkıştırıldı",
  "Compress New": "Yeni Sıkıştır",
  "Compression is complete": "Sıkıştırma tamamlandı",
  "Compression failed": "Sıkıştırma başarısız",
  "Quality": "Kalite",
  "Format": "Biçim",
  "Add file": "Dosya Ekle",
  "Output Settings": "Çıktı Ayarları",

};
